import { inject, Injectable } from '@angular/core';
import { AppStyleService } from 'src/app/core/services/app-style.service';
import { AppIntroService } from '../app-intro/app-intro.service';

@Injectable({
  providedIn: 'root',
})
export class StartupErrorService {
  protected container: string = 'startup-errors';
  protected serverErrorId: string = 'server-error';
  protected serverUpdateId: string = 'server-updating';
  appIntroService = inject(AppIntroService);
  appStyleService = inject(AppStyleService);

  constructor() {}

  toggleShowServerError() {
    this.#toggleClass(this.serverErrorId);
  }

  toggleShowServerUpdate() {
    this.#toggleClass(this.serverUpdateId);
  }

  #toggleClass(id) {
    this.appIntroService.destroy();

    this.appStyleService.initThemeMode();
    
    const containerElement = document.getElementById(
      this.container
    ) as HTMLElement;
    const HTMLelement = document.getElementById(id) as HTMLElement;
    containerElement.classList.toggle('display-none');
    HTMLelement.classList.toggle('display-none');
    document
      .getElementsByTagName('html')[0]
      .classList.toggle('overflow-hidden');
  }
}
